import { useSelector } from 'react-redux';

/*
 * Grabs auth state from Redux store and returns related user properties
 */
function useAuth() {
  const auth = useSelector((state) => state.auth);

  const isAdmin = auth.loggedIn && auth.userData.admin;
  const isCateringUser = !isAdmin && auth.loggedIn && auth.userData.catering_user;
  const isVendorUser = !isAdmin && !isCateringUser && auth.loggedIn;

  let dashboardLink = '/welcome';
  if (isCateringUser) {
    dashboardLink = '/catering/dashboard';
  } else if (isVendorUser) {
    const { trucks } = auth.userData;
    const hasTruck = trucks && trucks.length > 0;
    dashboardLink = hasTruck ? ('/vendor/truck/' + trucks[0].slug) : '/vendor';
  } else if (isAdmin) {
    dashboardLink = '/admin';
  }

  const inputProps = {
    auth,
    admin: isAdmin,
    cateringUser: isCateringUser,
    vendorUser: isVendorUser,
    dashboardLink,
  };

  return inputProps;
}

export default useAuth;
